module.exports = __webpack_public_path__ + "img/CS-Hybrid-Overview.7f93d131.jpg";